import { renderEUDate } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const getCellStyle = (cell) => {};

const columns = [
  {
    size: 180,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorFn: (row) => `${row.first_name} ${row.last_name}`,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.isOutOfBounds) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Paziente",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["Temperature"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    accessorFn: (row) =>
      row.recap.data.Temperature === undefined
        ? ""
        : `${row.recap.data.Temperature}°C`,
    header: "Temperatura",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["Pmax"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.Pmax === undefined ? "" : `${row.recap.data.Pmax}`,
    header: "Pmax",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["Pmin"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.Pmin === undefined ? "" : `${row.recap.data.Pmin}`,
    header: "Pmin",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["HR"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.HR === undefined ? "" : `${row.recap.data.HR}`,
    header: "HR",
  },
  {
    size: 50,
    enableColumnFilter: false,
    muiTableBodyCellProps: ({ cell, row, table }) => {
      if (row.original.recap.outOfBounds["SPO2"]) {
        return {
          sx: {
            color: "red",
          },
        };
      }
    },
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    accessorFn: (row) =>
      row.recap.data.SPO2 === undefined ? "" : `${row.recap.data.SPO2}`,
    header: "SPO2",
  },
  {
    size: 120,
    enableColumnFilter: false,
    accessorFn: (row) => renderEUDate(row.recap.date),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Data",
  },
  {
    size: 5,
    enableColumnFilter: false,
    accessorFn: (row) => (row.alert ? "true" : "false"),
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <CloseIcon color="error" />
      ) : (
        <DoneIcon color="success" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Alert",
  },
];

export default columns;
